import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BaseStoreFacade } from '@city/data-access';
import { PromoService } from '@promo/data-access';
import { map, Observable, tap } from 'rxjs';

export const promoResolver: ResolveFn<null> = (): Observable<null> => {
  const baseStoreFacade = inject(BaseStoreFacade);
  const promoService = inject(PromoService);

  return baseStoreFacade.getActiveCode().pipe(
    tap((baseStoreCode) => promoService.loadPromo(baseStoreCode)),
    map(() => null),
  );
};
